import { useStorage } from '@vueuse/core';
import { disable, enable, isEnabled } from 'darkreader';
import { computed, watch } from 'vue';

export type ThemeMode = 'light' | 'dark';

const mode = useStorage<ThemeMode>('yi-theme', 'light');
const isDark = computed(() => mode.value === 'dark');
let initialized = false;

function applyTheme(value: ThemeMode) {
  document.documentElement.dataset.colorMode = value;

  if (value === 'dark') {
    if (!isEnabled()) {
      enable({
        brightness: 100,
        contrast: 100,
        sepia: 0,
      });
    }
    return;
  }

  if (isEnabled())
    disable();
}

export function initializeTheme() {
  if (initialized)
    return;

  initialized = true;

  if (mode.value !== 'light' && mode.value !== 'dark')
    mode.value = 'light';

  watch(mode, applyTheme, {
    immediate: true,
    flush: 'sync',
  });
}

export function useTheme() {
  initializeTheme();

  function setTheme(value: ThemeMode) {
    mode.value = value;
  }

  function toggleTheme() {
    setTheme(isDark.value ? 'light' : 'dark');
  }

  return {
    mode,
    isDark,
    setTheme,
    toggleTheme,
  };
}
